import { v4 as uuidv4 } from "uuid";

export function generateUUID(): string {
  return uuidv4();
}

export async function sleep(number: number) {
  return new Promise((resolve) => setTimeout(resolve, number));
}

export const numToArray = (num: number) => {
  return [...Array(num)].map((_, i) => i)
}

export const replaceToBr = (str: string | undefined) => {
  return str?.replace(/\n/g, '<br />') ?? ""

}